import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-study-route-to-landing": () => import("/opt/build/repo/middleware/redirectStudyRouteToLanding.ts"),
  "redirect-wrong-namings": () => import("/opt/build/repo/middleware/redirectWrongNamings.ts")
}